import '.d{display:flex;}.ssr-plugin'
import '.a2{align-items:stretch;}.ssr-plugin'
import '.at{justify-content:center;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.d1{background:var(--palette-white);}.ssr-plugin'
import '.ds{flex-grow:1;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.al{max-width:77.5rem;}.ssr-plugin'
import '.f3{justify-content:stretch;}.ssr-plugin'
import '.ax{position:sticky;}.ssr-plugin'
import '.ay{top:0px;}.ssr-plugin'
import '.b4{z-index:10;}.ssr-plugin'
import '.f4{padding-block:1rem;}.ssr-plugin'
import '.f5{height:3rem;}.ssr-plugin'
import '.be{justify-content:space-between;}.ssr-plugin'
import '.c1{flex-wrap:wrap;}.ssr-plugin'
import '.f6{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.e7{margin-top:2rem;}.ssr-plugin'
import '.gr{padding-bottom:1.5rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'

export const InitiativeCreatePageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <ClientOnly>
      <div className="d a2 at e d1"
      >
        <div className="ds d r at e"
        >
          <div className="al d e f3 ax ay b4"
            style={{
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            <nav className="f4 f5 d be r c1"
            >
              <Title.H5>{title}</Title.H5>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="f6 d e a2 e7 gr al"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '85%', // 8rem is padding + navbar height
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
    </ClientOnly>
  )
}
